var map = {
	"./assets-hhl/img/az/quanqiugou_android_cdn.png": "9036",
	"./assets-mc/img/az/quanqiugou_android_cdn.png": "98ca",
	"./img/az/quanqiugou_android_cdn.png": "2bb0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8324";